<template>
    <el-scrollbar>
        <div class="view-modal window-scorll">
            <div class="map">
                <el-row :gutter="20" class="mb-2">
                    <el-col :span="6">
                        <div id="allmapa" class="allmap" ref="allmapa"></div>
                    </el-col>
                    <el-col :span="18" style="height:500px">
                        <v-map @selectLocation="selectLocation"></v-map>
                    </el-col>
                </el-row>
            </div>
        </div>
    </el-scrollbar>
</template>
<script>
    import MapA from './map-a.vue'
    export default{
        name:'map-tem',
        data(){
            return {}
        },
        components:{
            'v-map': MapA
        },
        created(){
            this.$parent.routerLoading();
        },
        methods:{
            selectLocation (location) {
              console.log(location)
              console.log(parseFloat(location.lng))
              console.log(parseFloat(location.lat))
            },
            map1(){
                let map =new BMap.Map(this.$refs.allmapa); // 创建Map实例
                map.centerAndZoom(new BMap.Point(116.404, 39.915), 11);// 初始化地图,设置中心点坐标和地图级别
                map.addControl(
                    new BMap.MapTypeControl({//添加地图类型控件
                        mapTypes:[
                            BMAP_NORMAL_MAP,
                            BMAP_HYBRID_MAP
                        ]
                    })
                );
                map.setCurrentCity("北京");// 设置地图显示的城市 此项是必须设置的
                map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
            },
        },
        mounted(){
            this.map1();
        },
    }
</script>
<style scoped>
.allmap{
  height: 500px;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/main-content/map/map-tem.vue